import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

import { Select2Data } from "../../../utils/common";

export const AllPermmission = createAsyncThunk(
  "common/masters/all-permission",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllPermmission);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllRoles = createAsyncThunk(
  "common/masters/all-role",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllRoles}?name=${filter}`);

      return await Select2Data(res.data, "role_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Country - Get All
export const AllCountry = createAsyncThunk(
  "common/masters/all-country",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCountry}?name=${filter}`);

      return await Select2Data(res.data.data, "country_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// State - Get All (for a specific country)
export const AllState = createAsyncThunk(
  "common/masters/all-state/:id",
  async ({ countryId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllState}/${countryId}?name=${name}`,
      );

      // You can adjust Select2Data if necessary
      return await Select2Data(res.data.data, "state_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// City - Get All (for a specific state)
export const AllCity = createAsyncThunk(
  "common/masters/all-city/:id",
  async ({ stateId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCity}/${stateId}?name=${name}`);
      return await Select2Data(res.data.data, "city_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Pincode - Get All (for a specific city)
export const AllPincode = createAsyncThunk(
  "common/masters/all-pincode/:id",
  async ({ cityId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllPincode}/${cityId}?name=${name}`,
      );
      return await Select2Data(res.data.data, "pincode_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllProperty = createAsyncThunk(
  "common/masters/all-property-type",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllProperty}?name=${filter}`);

      return await Select2Data(res.data.data, "property_type_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllSubProperty = createAsyncThunk(
  "common/masters/all-sub-property/:id",
  async ({ subpropertyId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllSubProperty}/${subpropertyId}?name=${name}`,
      );

      // You can adjust Select2Data if necessary
      return await Select2Data(res.data.data, "sub_property_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllProperties = createAsyncThunk(
  "common/masters/all-property",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllProperties}?name=${filter}`);
      console.log(res, "resres");
      return await Select2Data(res.data, "property_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllQuestion = createAsyncThunk(
  "common/masters/all-question",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllQuestion}?name=${filter}`);

      return await Select2Data(res.data, "question_type_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Country - Get All
export const AllSaleType = createAsyncThunk(
  "common/masters/all-sale-type",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllSaleType}?name=${filter}`);

      return await Select2Data(res.data.data, "sale_type_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllBhk = createAsyncThunk(
  "common/masters/all-bhk",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllBhk}?name=${filter}`);

      return await Select2Data(res.data.data, "bhk_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllFloorPreference = createAsyncThunk(
  "common/masters/all-floor-preference",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllFloorPreference}?name=${filter}`,
      );

      return await Select2Data(res.data.data, "floor_preference_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllFurnishingType = createAsyncThunk(
  "common/masters/all-furnishing-type",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllFurnishingType}?name=${filter}`);

      return await Select2Data(res.data.data, "furnishing_type_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllAmenity = createAsyncThunk(
  "common/masters/all-amenity",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllAmenity}?name=${filter}`);

      return await Select2Data(res.data.data, "amenity_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllParkingSpace = createAsyncThunk(
  "common/masters/all-parking-space",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllParkingSpace}?name=${filter}`);

      return await Select2Data(res.data.data, "parking_space_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllRestriction = createAsyncThunk(
  "common/masters/all-restriction",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllRestriction}?name=${filter}`);

      return await Select2Data(res.data.data, "restriction_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllSecurity = createAsyncThunk(
  "common/masters/all-security",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllSecurity}?name=${filter}`);

      return await Select2Data(res.data.data, "restriction_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllStepFeature = createAsyncThunk(
  "common/masters/all-step-feature",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllStepFeature}?name=${filter}`);

      return await Select2Data(res.data.data, "step_feature_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Country - Get All
export const AllSubscriptionFeature = createAsyncThunk(
  "common/masters/all-subscription-feature",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllSubscriptionFeature}?name=${filter}`,
      );

      return await Select2Data(res.data.data, "subscription_feature_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Ticket_Raised - Get All
export const AllTicketRaised = createAsyncThunk(
  "common/masters/all-ticket-raised",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllTicketRaised}?name=${filter}`);

      return await Select2Data(res.data.data, "ticket_raised_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Country - Get All
export const AllProperty_Status = createAsyncThunk(
  "common/masters/all-property-status",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllProperty_Status}?name=${filter}`,
      );

      return await Select2Data(res.data.data, "property_status_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllProject = createAsyncThunk(
  "common/masters/all-project",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllProject}?name=${filter}`);

      return await Select2Data(res.data.data, "project_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllUser = createAsyncThunk(
  "common/masters/all-user",
  async ({ id } = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllUser}`);

      return await Select2Data(res.data.data, "id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllBuilder = createAsyncThunk(
  "common/masters/all-builder",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllBuilder}?name=${filter}`);

      return await Select2Data(res.data.data, "user_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllBannerType = createAsyncThunk(
  "common/masters/all-banner-type",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllBannerType}?name=${filter}`);

      return await Select2Data(res.data.data, "banner_type_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetBhksByProject = createAsyncThunk(
  "common/masters/bhks-by-project",
  async ({ projectId }, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.GetBhksByProject}/${projectId}`);
      return res.data.bhkIds || [];
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// export const AssignedCustomers = createAsyncThunk(
//   "common/masters/assigned-customers",
//   async (_, { rejectWithValue }) => {
//     try {
//       const res = await GET(APIS.Commons.AllAssignedCustomer);
//       return await Select2Data(res.data.data, "user_id");
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

export const AllSalesPerson = createAsyncThunk(
  "common/masters/all-sales-person",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllSalesPerson}?name=${filter}`);

      return await Select2Data(res.data.data, "user_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Country - Get All
export const AllNotificationUser = createAsyncThunk(
  "common/masters/all-notification-user",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllNotificationUser}?name=${filter}`,
      );

      return await Select2Data(res.data.data, "user_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllTrackingAssign = createAsyncThunk(
  "common/masters/all-tracking-assign-user",
  async (customer_id, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllTrackingAssign}?customer_id=${customer_id}`,
      );
      const rows = res?.data || [];
      console.log(rows, "ggggggggggggggggggggggggggggggggggg");

      // 🔑 map response into { value, label } for react-select
      const options = rows.map((r) => ({
        value: r.id, // Use Tracking_Assign.id instead of r.builder?.id
        label: r.builder?.name || `Builder #${r.builder_id}`,
        builder_id: r.builder_id,
      }));

      return options;
    } catch (error) {
      return rejectWithValue(
        error?.message || "Failed to load assigned builders",
      );
    }
  },
);

// TermsType - Get All
export const AllTermsType = createAsyncThunk(
  "common/masters/all-term-type",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllTermsType}?name=${filter}`);

      return await Select2Data(res.data.data, "term_type_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// TermsType - Get All
export const AllTermsCondition = createAsyncThunk(
  "common/masters/all-term-condition",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllTermsCondition}?name=${filter}`);

      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllPropertyMakingStatus = createAsyncThunk(
  "common/masters/property-making-status",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllPropertyMakingStatus}?name=${filter}`,
      );

      return await Select2Data(res.data.data, "property_making_status_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllAmenities = createAsyncThunk(
  "common/masters/amenity",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllAmenities);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// export const AllCoupnType = createAsyncThunk(
//   "common/masters/coupn-type",
//   async (filter, { rejectWithValue }) => {
//     try {
//       const res = await GET(APIS.Commons.AllCoupnType);

//       return res?.data;
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   },
// );

export const AllCoupnType = createAsyncThunk(
  "common/masters/coupn-type",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCoupnType}?name=${filter}`);

      return await Select2Data(res.data.data, "coupn_type_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllKycStatus = createAsyncThunk(
  "common/masters/all-kyc-status",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllKycStatus}?name=${filter}`);

      return await Select2Data(res.data.data, "kyc_status_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "common",
  initialState: {
    all_country: [],
    all_state: [],
    all_city: [],
    all_pincode: [],
    all_property_type: [],
    all_sub_property: [],
    all_property: [],
    all_question_type: [],
    all_sale_type: [],
    all_bhk: [],
    all_floor_preference: [],
    all_furnishing_type: [],
    all_amenity: [],
    all_parking_space: [],
    all_restriction: [],
    all_security: [],
    all_step_feature: [],
    all_subscription_feature: [],
    all_ticket_raised: [],
    all_property_status: [],
    all_project: [],
    all_permission: {
      adminPermissions: [],
      builderPermissions: [],
    },
    all_roles: [],
    all_user: [],
    all_builder: [],
    assigned_customers: [],
    all_banner_type: [],
    bhks_by_project: [],
    all_sales_person: [],
    all_notification_user: [],
    all_tracking_assign: [],
    all_terms_type: [],
    all_terms_condition: [],
    all_property_making_status: [],
    all_amenities: [],
    all_coupn_type: [],
    all_kyc_status: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(AllCountry.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCountry.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_country = action.payload || [];
      })
      .addCase(AllCountry.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllState actions
      .addCase(AllState.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllState.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_state = action.payload || [];
      })
      .addCase(AllState.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllCity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCity.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_city = action.payload || [];
      })
      .addCase(AllCity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllPincode actions
      .addCase(AllPincode.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPincode.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_pincode = action.payload || [];
      })
      .addCase(AllPincode.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllProperty.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllProperty.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_property_type = action.payload || [];
      })
      .addCase(AllProperty.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllSubProperty.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllSubProperty.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_sub_property = action.payload || [];
      })
      .addCase(AllSubProperty.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllProperties.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllProperties.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_property = action.payload || [];
      })
      .addCase(AllProperties.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllQuestion.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllQuestion.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_question_type = action.payload || [];
      })
      .addCase(AllQuestion.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // .addCase(AllPermmission.pending, (state) => {
      //   console.log("action.payload pending");
      //   state.status = IDS.SLICESTATUS.Loading;
      // })
      // .addCase(AllPermmission.fulfilled, (state, action) => {
      //   state.status = IDS.SLICESTATUS.Succeeded;

      //   state.all_permission = action.payload || {};
      // })
      // .addCase(AllPermmission.rejected, (state, action) => {
      //   state.status = IDS.SLICESTATUS.Failed;

      //   state.error = action.payload;
      // })

      .addCase(AllPermmission.pending, (state) => {
        console.log("AllPermmission pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPermmission.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_permission = action.payload || {
          adminPermissions: [],
          builderPermissions: [],
        };
      })
      .addCase(AllPermmission.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllRoles.pending, (state) => {
        console.log("action.payload pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllRoles.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;

        state.all_roles = action.payload || [];
      })
      .addCase(AllRoles.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;

        state.error = action.payload;
      })

      .addCase(AllSaleType.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllSaleType.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_sale_type = action.payload || [];
      })
      .addCase(AllSaleType.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllBhk.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllBhk.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_bhk = action.payload || [];
      })
      .addCase(AllBhk.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllFloorPreference.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllFloorPreference.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_floor_preference = action.payload || [];
      })
      .addCase(AllFloorPreference.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllFurnishingType.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllFurnishingType.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_furnishing_type = action.payload || [];
      })
      .addCase(AllFurnishingType.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllAmenity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllAmenity.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_amenity = action.payload || [];
      })
      .addCase(AllAmenity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllParkingSpace.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllParkingSpace.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_parking_space = action.payload || [];
      })
      .addCase(AllParkingSpace.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllRestriction.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllRestriction.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_restriction = action.payload || [];
      })
      .addCase(AllRestriction.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllSecurity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllSecurity.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_security = action.payload || [];
      })
      .addCase(AllSecurity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllStepFeature.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllStepFeature.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_step_feature = action.payload || [];
      })
      .addCase(AllStepFeature.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllSubscriptionFeature.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllSubscriptionFeature.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_subscription_feature = action.payload || [];
      })
      .addCase(AllSubscriptionFeature.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllTicketRaised.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllTicketRaised.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_ticket_raised = action.payload || [];
      })
      .addCase(AllTicketRaised.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllProperty_Status.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllProperty_Status.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_property_status = action.payload || [];
      })
      .addCase(AllProperty_Status.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllProject.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllProject.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_project = action.payload || [];
      })
      .addCase(AllProject.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllUser.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllUser.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_user = action.payload || [];
      })
      .addCase(AllUser.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllBuilder.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllBuilder.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_builder = action.payload || [];
      })
      .addCase(AllBuilder.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllBannerType.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllBannerType.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_banner_type = action.payload || [];
      })
      .addCase(AllBannerType.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetBhksByProject.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetBhksByProject.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.bhks_by_project = action.payload || [];
      })
      .addCase(GetBhksByProject.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllNotificationUser.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllNotificationUser.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_notification_user = action.payload || [];
      })
      .addCase(AllNotificationUser.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllSalesPerson.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllSalesPerson.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_sales_person = action.payload || [];
      })
      .addCase(AllSalesPerson.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllTrackingAssign.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllTrackingAssign.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_tracking_assign = action.payload || [];
      })
      .addCase(AllTrackingAssign.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllTermsType.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllTermsType.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_terms_type = action.payload || [];
      })
      .addCase(AllTermsType.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllTermsCondition.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllTermsCondition.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_terms_condition = action.payload || [];
      })
      .addCase(AllTermsCondition.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllPropertyMakingStatus.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPropertyMakingStatus.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_property_making_status = action.payload || [];
      })
      .addCase(AllPropertyMakingStatus.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllAmenities.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllAmenities.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_amenities = action.payload || [];
      })
      .addCase(AllAmenities.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllCoupnType.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCoupnType.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_coupn_type = action.payload || [];
      })
      .addCase(AllCoupnType.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllKycStatus.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllKycStatus.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_kyc_status = action.payload || [];
      })
      .addCase(AllKycStatus.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
